module.exports = __webpack_public_path__ + "static/media/icon-clip.4e5ecaa1.svg";